import { ISettingsItemGroup } from "src/modules/idom-settings/models/settings";

export interface IIdomSettingsStateInterface {
  settings: ISettingsItemGroup[];
}

function state(): IIdomSettingsStateInterface {
  return {
    settings: [],
  };
}

export default state;
